export default __webpack_public_path__ + "static/media/element_82.76314506.jpg";